import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { ControlsService } from '../controls.service';

@Component({
  selector: 'app-login-reminder-modal',
  templateUrl: './login-reminder-modal.component.html',
  styleUrls: ['./login-reminder-modal.component.scss']
})
export class LoginReminderModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LoginReminderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cs: ControlsService) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onEnterLicense(event): void{

    this.cs.setLicenseModalControlSubject({message: ''});

    this.onNoClick();

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/login-reminder-modal/login-reminder-modal.component.ts